import { render, staticRenderFns } from "./SelectFranchise.vue?vue&type=template&id=ddbc27d8&"
import script from "./SelectFranchise.vue?vue&type=script&lang=js&"
export * from "./SelectFranchise.vue?vue&type=script&lang=js&"
import style0 from "./SelectFranchise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports